<template>
  <div>
    <LmListV2
      ref='LmDocumentTypesListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Tipos de Documentos',
      gqlField: 'DocumentTypes',
      gqlVariables: {
        q: 'deleted: false',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[DocumentTypesESSortEnum]) {
      DocumentTypes(
          titleList: "Listado de Tipos de Documentos"
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/listbuilder/view/:listbuilderId",tooltip:"Documentos",fontAwesomeIcon:"file-alt"},{to:"/tiposdedocumento/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/tiposdedocumento/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info"}]

          ) {
          count
          searcher
          tableItemsTotal
          titleList
          table {
            items {
              typeName,typeAlias,createdAt,publish,isEditable,updatedAt,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: [
        'typeName',
        'publish',
        'isEditable',
        'createdAt',
        'updatedAt',
        'listbuilderId',
        'formbuilderId',
        'actions'
      ],
      searchOnFieldsToSelected: [
        'typeName',
        'createdAt',
        'publish',
        'isEditable',
        'updatedAt',
        'actions'
      ],
      items: [
        {
          name: 'id'
        },
        {
          name: 'typeName'
        },
        {
          name: 'typeDescription'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'publish'
        },
        {
          name: 'isEditable'
        },
        {
          name: 'deleted'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'listbuilderId'
        },
        {
          name: 'formbuilderId'
        },
        {
          name: 'privileges'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        },
        {
          name: 'actions'
        }
      ],
      mode: {
        table: true,
        map: false
      },
      fields: [
        {
          key: 'typeName',
          label: 'Nombre',
          sortable: false
        },
        {
          key: 'typeAlias',
          label: 'Alias',
          sortable: false
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        },
        {
          key: 'publish',
          label: 'Publicado',
          sortable: true
        },
        {
          key: 'isEditable',
          label: 'Es editable',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: 'Actualizado',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
